<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />
    <div
      style="
        width: 1200px;
        margin: auto;
        padding-bottom: 10%;
        overflow: hidden;
        height: 400px;
        background: #fff;
      "
    >
      <div style="margin-top: 20px">
        <div style="float: left; overflow: hidden; width: 100%">
          <img
            src="../assets/wangjimima_zhengque.png"
            style="width: 44px; height: 44px; float: left"
            alt=""
          />
          <div class="title1" style="line-height: 44px; padding-bottom: 20px">
            您已付款成功!
          </div>
        </div>
        <div style="margin-top: 40px; margin-left: 64px">
          <div style="margin-top: 10px">订单编号：{{order.orderSn}}</div>
          <div style="margin-top: 10px">
            收货地址：
            <span style="margin-right: 10px">{{address.consignee}}</span>
            <span style="margin-right: 20px">{{address.phone}}</span>
            <span>{{address.province}}{{address.city}}{{address.county}}{{address.address}}</span>
          </div>
          <div style="margin-top: 10px">
            实付款 <span style="color: #f24145">{{price|moneyStr}}</span>
          </div>
          <div style="margin-top: 20px">
            你可以
            <span
              @click="to_order"
              style="cursor: pointer; color: #2b9a34; margin-left: 20px"
              >查看已买到的宝贝</span
            >
            <!-- <span @click="to_order_details" style="margin-left: 20px; color: #2B9A34; cursor: pointer;">查看交易详情</span> -->
          </div>
        </div>
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import axios from "axios";
import userLeft from "../public/user_left";
import htmlHeader from "../public/head";
import foot from "../public/foot";
export default {
  name: "integral",
  components: {
    userLeft,
    htmlHeader,
    foot,
  },
  data() {
    return {
      order_id: '',
      order_pay_id: '',
      order: {},
      address: {},
      price: 0,
    };
  },
  filters: {
    moneyStr(value) {
      value = value ? value / 100 : 0
      return '￥' + value.toFixed(2)
    },
  },
  methods: {
    to_order_details() {
      this.$router.push("/pay_to?uuid=" + this.$route.query.uuid);
    },
    to_order() {
      this.$router.push("/order");
    },
    getInfo() {
      this.api.get_order_jindu(this.order_id)
        .then(res => {
          if (res.ok) {
            this.address = res.data.receiverBean
            this.order = res.data
          }
        })
    },
    getPayOrder(id) {
      this.api.payOrder(id)
        .then(res => {
          if (res.ok && res.data) {
            this.price = res.data.amount
          }
        })
    },
    //清除url
    get_url(){
        //我也不知道为什么要加这个方法,但是有问题,我就先注释了
        // window.location.href = `/#/pay_successful?uuid=${this.order_id}`
        
    }
  },
  created() {
    const order_id = this.$route.query.uuid
    const order_pay_id = this.$route.query.pid
    if (order_id) {
      this.order_id = order_id
      this.getInfo()
    }
    if (order_pay_id) {
      this.getPayOrder(order_pay_id)
    }
    this.get_url()
  },
};
</script>

<style scoped>
.title1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  float: left;
  margin-left: 20px;
}
.txt1 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/pay_successful.vue